module.exports = __webpack_public_path__ + "strengthen.svg?76ae8c09f74fcb910ccfa3b467530f4e";